import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { map } from 'rxjs'

import { environment } from '../../../environments/environment'
import { HelperService } from '../../shared/services/helper.service'
import { ApiResponse } from '../../shared/types/response.type'
import { MyProfile } from './types/my-profile.type'

const API_URL = environment.apiUrl

@Injectable({
	providedIn: 'root',
})
export class MyProfileService {
	constructor(
		private readonly httpClient: HttpClient,
		private readonly helperService: HelperService,
	) {}

	getMyProfile() {
		const userId = this.helperService.getUserData()?.user_fields?.ID

		return this.httpClient.get<ApiResponse<MyProfile[]>>(`${API_URL}/api/users/getById/${userId}`).pipe(map((response) => response.result))
	}

	updateProfile(profile: Partial<MyProfile>) {
		const userId = this.helperService.getUserData()?.user_fields?.ID

		return this.httpClient.post<ApiResponse<string>>(`${API_URL}/api/users/update_profile`, { ...profile, USER_ID: userId })
	}
}
